module.exports = __webpack_public_path__ + "static/media/exclamation-triangle.ea10af7f.svg";